import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import GuestPageStore from '@src/pages/guest/store';
import GuestShell from '@src/ui-components/guest';
import Page from '../../components/page';

const styles = require('./index.less');

const GuestView = observer(() => {
  const store = useStore(() => new GuestPageStore());

  return (
    <Page className={styles.root}>
      <GuestShell viewModel={store.guestViewModel} onLike={store.like} onInvite={store.copyInviteShare} onJoin={store.enterMain} />
    </Page>
  );
});

export default function Guest() {
  return <GuestView />;
}
